import React, { useEffect, useState } from "react";
import * as core from "@material-ui/core";
import { useTranslation } from "react-i18next";
import CreatableSelect from "react-select/creatable";
import { WorkerDemanderService } from "src/services";

const WorkLocation = (props) => {
  console.log(props);
  const {
    touched,
    errors,
    values,
    handleBlur,
    handleChange,
    setFieldValue,
    role,
    countryList,
    getResult,
    cityList,
  } = props;
  const { t } = useTranslation();

  const [addresses, setAddresses] = useState([]);
  const [addressEnable, setAddressEnable] = useState(true);

  const getAddressList = async () => {
    try {
      let addressList = [];
      const response =
        await WorkerDemanderService.GET_WORKER_DEMANDERS_WITH_EXTRA_ASYNC(
          values.workerDemanderId
        );
      const { success, message } = await response.data;
      if (success) {
        const { data } = await response.data;
        console.log(data);
        if (data) {
          data.addressList.forEach((rc) => {
            addressList.push({
              value: rc.id,
              label:
                rc.countryCode +
                "," +
                rc.city +
                "," +
                rc.postCode +
                "," +
                rc.detail,
            });
          });
          setAddresses(addressList);
        }
      } else {
        console.error(message);
      }
    } catch (error) {
      const { message, response } = error;
      if (response) {
        const { data } = response;
        if (data) {
          console.error(JSON.stringify(data));
        }
      } else {
        console.error(JSON.stringify(message));
      }
    }
  };

  useEffect(() => {
    const callAPI = async () => {
      if (
        ["Admin", "Client", "Accountant"].includes(role) &&
        values.workerDemanderId !== 0
      ) {
        await getAddressList();
      }
    };

    callAPI();
  }, []);

  return (
    <core.Card>
      <core.CardHeader title={t("pages.workrequest.workLocation.stepname")} />

      <core.Divider />
      <core.CardContent>
        <core.Grid container spacing={4}>
          <core.Grid item md={12} xs={12}>
            {["Admin", "Client", "Accountant"].includes(role) ? (
              <core.Paper elevation={4}>
                <CreatableSelect
                  fullWidth
                  isClearable
                  name="selectedAddressId"
                  onBlur={handleBlur}
                  value={{
                    value: values.selectedAddressId || undefined,
                    label: values.selectedAddressName || undefined,
                  }}
                  onChange={(newValue, actionMeta) => {
                    if (newValue) {
                      setFieldValue(
                        "selectedAddressId",
                        Number(newValue.value)
                      );
                      setFieldValue("selectedAddressName", newValue.label);
                      setAddressEnable(false);
                    } else {
                      setFieldValue("selectedAddressId", 0);
                      setFieldValue("selectedAddressName", "");
                      setAddressEnable(true);
                    }
                  }}
                  options={addresses}
                />
              </core.Paper>
            ) : null}
          </core.Grid>

          <core.Grid item md={12} xs={12}>
            <div
              id="cover"
              style={
                !addressEnable ? { pointerEvents: "none", opacity: 0.7 } : null
              }
            >
              <core.Paper elevation={1}>
                <core.Box p={5}>
                  <core.Grid container spacing={2}>
                    <core.Grid item md={6} xs={12}>
                      <core.TextField
                        fullWidth
                        label={t("address.countryCode")}
                        name="selectedAddress.countryCode"
                        select
                        SelectProps={{ native: true }}
                        InputLabelProps={{ shrink: true }}
                        error={Boolean(
                          touched.selectedAddress?.countryCode &&
                            errors.selectedAddress?.countryCode
                        )}
                        onBlur={handleBlur}
                        onChange={(event) => {
                          handleChange(event);
                          setFieldValue("selectedAddressId", 0);
                          setFieldValue("selectedAddressName", "");
                          props.getResult(event.target.value + "Cities");
                        }}
                        value={values.selectedAddress?.countryCode}
                      >
                        {countryList?.map((option) => (
                          <option
                            key={option.metadataCode}
                            value={option.metadataCode}
                          >
                            {option.metadataValue}
                          </option>
                        ))}
                      </core.TextField>
                    </core.Grid>
                    <core.Grid item md={6} xs={12}>
                      <core.TextField
                        fullWidth
                        label={t("address.city")}
                        name="selectedAddress.city"
                        select
                        SelectProps={{ native: true }}
                        InputLabelProps={{ shrink: true }}
                        error={Boolean(
                          touched.selectedAddress?.city &&
                            errors.selectedAddress?.city
                        )}
                        onBlur={handleBlur}
                        onChange={(event) => {
                          handleChange(event);
                          setFieldValue("selectedAddressId", 0);
                          setFieldValue("selectedAddressName", "");
                        }}
                        value={values.selectedAddress?.city || undefined}
                      >
                        {cityList?.map((option) => (
                          <option
                            key={option.metadataCode}
                            value={option.metadataCode}
                          >
                            {option.metadataValue}
                          </option>
                        ))}
                      </core.TextField>
                    </core.Grid>
                    <core.Grid item md={6} xs={12}>
                      <core.TextField
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        label={t("address.postCode")}
                        name="selectedAddress.postCode"
                        error={Boolean(
                          touched.selectedAddress?.postCode &&
                            errors.selectedAddress?.postCode
                        )}
                        onBlur={handleBlur}
                        onChange={(event) => {
                          handleChange(event);
                          setFieldValue("selectedAddressId", 0);
                          setFieldValue("selectedAddressName", "");
                        }}
                        value={values.selectedAddress?.postCode}
                      />
                    </core.Grid>
                    <core.Grid item md={6} xs={12}>
                      <core.TextField
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        label={t("address.detail")}
                        name="selectedAddress.detail"
                        error={Boolean(
                          touched.selectedAddress?.detail &&
                            errors.selectedAddress?.detail
                        )}
                        onBlur={handleBlur}
                        onChange={(event) => {
                          handleChange(event);
                          setFieldValue("selectedAddressId", 0);
                          setFieldValue("selectedAddressName", "");
                        }}
                        value={values.selectedAddress?.detail}
                      />
                    </core.Grid>
                  </core.Grid>
                </core.Box>
              </core.Paper>
            </div>
          </core.Grid>
        </core.Grid>
      </core.CardContent>

      {/* Master state
      <pre>{JSON.stringify(props.values, null, 2)}</pre> */}
    </core.Card>
  );
};

export default WorkLocation;
